import { AxiosError } from 'axios';
import { ActionType } from 'typesafe-actions';
import { Enterprise } from '../auth';
import { Project } from '../projects';
import * as actions from './actions';

export type ContractsAction = ActionType<typeof actions>;

export interface ContractsState {
  contracts: {
    data: Contract[] | null;
    loading: boolean;
    error: AxiosError | null;
  };
  contract: {
    data: Contract | null;
    loading: boolean;
    error: AxiosError | null;
  };
}

export interface Contract {
  id: number;
  projectId?: string;
  contractId?: string;
  project: Partial<Project>;
  enterprise: Partial<Enterprise>;
  title: string;
  type1: ContractType;
  type2: string;
  contractNum: string;
  contractCompany: any;
  status: ContractStatus;
  contractDate: string;
  deliveryDate: string;
  startDate: string;
  endDate: string;
  actualEndDate: string | null;

  description: string;
  ownerName?: string;
  shipTo: string;
  attachFilePath: string;
  createdAt: string;
  updatedAt: string;
  attachedFiles: any[];
  submittedFiles: any[];
  sov: any;
  sovTotal: number;
  changeOrderSovTotal: number;
  paymentTotal: number;
  contractTotal?: number;
  paymentRate?: number;
  editable?: boolean;
  attachFiles: AttachFile[];
  invoiceContactUsers?: any;
  eSignDocumentId: string;

  metaData: any;
  priceData: any;
  changeOrders: any[];

  /*

    advancedFeeRate: number;
  performanceBondRate: number;
  securityDepositBondRate: number;

  // 하자담보책임기간
  correctionPeriod: number;

  // // 선급금 지급일
  // advancedFeePaymentDate: number;

  // // 기성금 지급 개월
  // compmetedAmountPaymentMonth: number;

  // // 기성금 지급 횟수
  // compmetedAmountPaymentCount: number;

  // // 기성금 지급일
  // compmetedAmountPaymentDate: number;

  // // 기성금 지급방법 현금 비율
  // compmetedAmountCashRate: number;

  // // 기성금 지급방법 어음 비율
  // compmetedAmountDraftRate: number;

  // // 기성금 지급방법 어음대체결제수단 비율
  // compmetedAmountAlternativeDraftRate: number;

  // 간접노무비 요율
  costAccountingSheetRate0: number;

  // 산재보험료 요율
  costAccountingSheetRate1: number;

  // 고용보험료 요율
  costAccountingSheetRate2: number;

  // 국민건강보험료 요율
  costAccountingSheetRate3: number;

  // 국민연금보험료 요율
  costAccountingSheetRate4: number;

  // 노인장기요양보험료 요율
  costAccountingSheetRate5: number;

  // 퇴직공제부금비 요율
  costAccountingSheetRate6: number;

  // 산업안전보건관리비 요율
  costAccountingSheetRate7: number;

  // 기타 경비 요율
  costAccountingSheetRate8: number;

  // 환경보전비 요율
  costAccountingSheetRate9: number;

  // 건설하도급대금지급보증서발급수수료 요율
  costAccountingSheetRate10: number;

  // 건설기계대여금지급보증서발급수수료 요율
  costAccountingSheetRate11: number;

  // 일반관리비 요율
  costAccountingSheetRate12: number;

  // 이윤 요율
  costAccountingSheetRate13: number;

  // 부가가치세 요율
  costAccountingSheetRate14: number;

  // 매입세 요율
  costAccountingSheetRate15: number;
  */
}

export interface AttachFile {
  id: number;
  name: string;
  path: string;
  mimeType: string;
}

export interface ContractSOV {
  id: number;
  projectId: number;
  contractId: number;
  contractType1: ContractType;
  editable: boolean;
  quantity: number;
  materialCost: number;
  laborCost: number;
  expense: number;
  materialCostTotal: number;
  laborCostTotal: number;
  expenseTotal: number;
  total: number;
}

export interface ContractParams {
  enterpriseId: string;
  projectId: string;
  contractType1: ContractType;
  contractId?: string;
  contract?: Contract;
  contractSOV?: ContractSOV;
  uploadedSOV?: any[];
  metaData?: any;
}

// export interface ContractListParams {
//   projectId: string;
//   contractType1: ContractType;
// }

// export interface ContractDetailParams {
//   enterpriseId: string;
//   projectId: string;
//   contractType1: ContractType;
//   contractId: string;
// }

export interface ContractMatchParams {
  enterpriseId: string;
  projectId: string;
  contractId: string;
}

export interface EmptyContractSOVParams {
  enterpriseId: string;
  projectId: string;
  contractId: string;
  codes: string[];
}

export const contractType1Enum = {
  PRIME_CONTRACT: '0',
  SUBCONTRACT_WORK: '1',
  SUBCONTRACT_PURCHASE: '2',
} as const;
export type ContractType =
  (typeof contractType1Enum)[keyof typeof contractType1Enum];

export const contractTypeKorean = {
  '0': '도급',
  '1': '외주',
  '2': '자재',
} as const;

export const contractStatusEnum = {
  DRAFT: '0',
  SUBMITTING_DOCUMENTS: '1',
  IN_REVIEW: '2',
  IN_SIGNATURE: '3',
  APPROVED: '4',
} as const;
export type ContractStatus =
  (typeof contractStatusEnum)[keyof typeof contractStatusEnum];

export const contractStatusKorean = {
  '0': '작성중',
  '1': '구비서류 제출중',
  '2': '검토중',
  '3': '전자서명중',
  '4': '계약완료',
} as const;
